import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './grid-operator-capacity-tariff.reducer';

export const GridOperatorCapacityTariffDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const gridOperatorCapacityTariffEntity = useAppSelector(state => state.gridOperatorCapacityTariff.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="gridOperatorCapacityTariffDetailsHeading">
          <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.detail.title">
            GridOperatorCapacityTariff
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{gridOperatorCapacityTariffEntity.id}</dd>
          <dt>
            <span id="tariff">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.tariff">Tariff</Translate>
            </span>
          </dt>
          <dd>{gridOperatorCapacityTariffEntity.tariff}</dd>
          <dt>
            <span id="effectiveDate">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.effectiveDate">
                Effective Date
              </Translate>
            </span>
          </dt>
          <dd>
            {gridOperatorCapacityTariffEntity.effectiveDate ? (
              <TextFormat
                value={gridOperatorCapacityTariffEntity.effectiveDate}
                type="date"
                format={APP_LOCAL_DATE_FORMAT}
              />
            ) : null}
          </dd>
          <dt>
            <span id="expirationDate">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.expirationDate">
                Expiration Date
              </Translate>
            </span>
          </dt>
          <dd>
            {gridOperatorCapacityTariffEntity.expirationDate ? (
              <TextFormat
                value={gridOperatorCapacityTariffEntity.expirationDate}
                type="date"
                format={APP_LOCAL_DATE_FORMAT}
              />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.gridOperatorCapacity">
              Grid Operator Capacity
            </Translate>
          </dt>
          <dd>
            {gridOperatorCapacityTariffEntity.gridOperatorCapacity
              ? gridOperatorCapacityTariffEntity.gridOperatorCapacity.capacityCode
              : ''}
          </dd>
        </dl>
        <Button tag={Link} to="/grid-operator-capacity-tariff" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/grid-operator-capacity-tariff/${gridOperatorCapacityTariffEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GridOperatorCapacityTariffDetail;
